import 'zone.js';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import {
  provideHttpClient,
  withFetch,
  withInterceptorsFromDi,
  HTTP_INTERCEPTORS
} from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { importProvidersFrom, provideZoneChangeDetection } from '@angular/core';

import { provideTransloco } from '@ngneat/transloco';
import { TranslocoHttpLoader } from './app/service/transloco-http-loader';

import { ToastrModule } from 'ngx-toastr';
import { ReactiveFormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';

import { AppComponent } from './app/app.component';
import { routes } from './app/app-routing.module';
import { TokenInterceptor } from './app/interceptor/token-interceptor.interceptor';
import { environment } from './environments/environment';

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    provideZoneChangeDetection({ eventCoalescing: true }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    DatePipe,
    provideTransloco({
      loader: TranslocoHttpLoader,
      config: {
        availableLangs: ['english', 'de', 'hindi'],
        defaultLang: 'english',
        reRenderOnLangChange: true,
        prodMode: environment.production,
      },
    }),
    importProvidersFrom(
      ReactiveFormsModule,
      ToastrModule.forRoot({
        progressBar: true,
        progressAnimation: 'decreasing',
        preventDuplicates: true,
        positionClass: 'toast-bottom-left'
      })
    ),
    // NgZone 
  ]
}).catch(console.error);
